import '@/styles/globals.css'
import '@/styles/webflow/normalize.css'
import '@/styles/webflow/webflow.css'
import '@/styles/webflow/wedoflow.webflow.css'
import '@/styles/custom.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Fragment } from 'react'

import { Analytics } from '@/components/generals/analytics'

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <Fragment>
            <Component {...pageProps} />
            <Analytics />
        </Fragment>
    )
}

export default App
